import { useMemo } from 'react';
import { useTRPCAPI, useTRPCQuery } from '../../trpc/trpc';
import { useUserToken } from '../../redux/slices/appInfo/hooks';

/** The onboarding answer of the server. It runs only for a signed-in person. */
export function useOnboardingState() {
  const trpcAPI = useTRPCAPI();
  const token = useUserToken();
  const query = useTRPCQuery(
    trpcAPI.onboarding.state.queryOptions(undefined, {
      enabled: token !== null && token !== '',
      staleTime: 30_000,
    })
  );
  const { data, isLoading, isError, error, refetch, fetchStatus } = query;
  // Offline, the query pauses: it is not an error, but no answer comes either.
  const isPaused = fetchStatus === 'paused';
  return useMemo(
    () => ({ state: data, isLoading, isError, error, isPaused, refetch }),
    [data, isLoading, isError, error, isPaused, refetch]
  );
}
